module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/4@2x_9a095bead79911fce2fa84db0ef9d1a7.png";